<template>
  <div class="opinion-feedback">
    <div class="card">
      <div class="field-label required">选择分类</div>
      <div class="type-list">
        <div
          class="type-item"
          v-for="(item, index) in typeList"
          :key="getTypeKey(item) || index"
          :class="{ on: selectedType === getTypeKey(item) }"
          @click="selectedType = getTypeKey(item)"
        >
          {{ getTypeLabel(item) }}
        </div>
      </div>
    </div>

    <div class="card">
      <div class="field-label required">{{ contentLabel }}</div>
      <div class="textarea-wrap">
        <textarea
          v-model="content"
          maxlength="300"
          placeholder="请留下您的宝贵意见（最少输入4个字）"
        ></textarea>
        <div class="char-count">还可以输入{{ remainChars }}字</div>
      </div>
      <div class="upload-list acea-row row-middle">
        <div
          class="upload-pic"
          v-for="(img, index) in images"
          :key="img + index"
        >
          <img :src="img" />
          <span
            class="iconfont icon-guanbi1 font-color-red"
            @click="removeImage(index)"
          ></span>
        </div>
        <div v-if="images.length < 3" class="picUploadSlot">
          <VueCoreImageUpload
            class="upload-pic upload-add acea-row row-center-wrapper row-column"
            :crop="false"
            compress="80"
            @imageuploading="onImageUploading"
            @imageuploaded="onImageUploaded"
            @errorhandle="onUploadError"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="uploadUrl"
          >
            <span class="iconfont icon-icon25201"></span>
            <div>添加照片</div>
            <div class="upload-tip">最多3张</div>
          </VueCoreImageUpload>
          <div
            v-if="imageUploading"
            class="picUploadMask acea-row row-center-wrapper row-column"
          >
            <span class="uploading-spinner"></span>
            <div>上传中...</div>
          </div>
        </div>
      </div>
    </div>

    <div class="card phone-card acea-row row-between-wrapper">
      <div class="field-label phone-label">联系电话</div>
      <input
        type="tel"
        v-model="phone"
        maxlength="11"
        placeholder="请填写可以联系到您的手机号码"
        class="phone-input"
      />
    </div>

    <div
      class="submit-btn"
      :class="{ active: canSubmit && !submitting }"
      @click="submit"
    >
      {{ submitting ? "提交中..." : "提交" }}
    </div>
    <div class="bottom-space"></div>
  </div>
</template>

<script>
import VueCoreImageUpload from "vue-core-image-upload";
import { trim, VUE_APP_API_URL } from "@utils";
import { getFeedbackTypes, submitFeedback } from "@api/user";
import { chs_phone } from "@utils/validate";

export default {
  name: "OpinionFeedback",
  components: {
    VueCoreImageUpload
  },
  data() {
    return {
      uploadUrl: `${VUE_APP_API_URL}/upload/image`,
      typeList: [],
      selectedType: "",
      content: "",
      images: [],
      phone: "",
      imageUploading: false,
      submitting: false,
      maxLength: 300
    };
  },
  computed: {
    headers() {
      return {
        "Authori-zation": "Bearer " + (this.$store.state.app.token || "")
      };
    },
    remainChars() {
      return this.maxLength - (this.content ? this.content.length : 0);
    },
    contentLabel() {
      return this.selectedType || "反馈内容";
    },
    canSubmit() {
      return this.selectedType !== "" && trim(this.content).length >= 4;
    }
  },
  mounted() {
    this.loadTypes();
  },
  methods: {
    loadTypes() {
      getFeedbackTypes()
        .then(res => {
          const data = res.data;
          if (Array.isArray(data)) {
            this.typeList = data;
          } else if (data && Array.isArray(data.list)) {
            this.typeList = data.list;
          } else if (data && Array.isArray(data.types)) {
            this.typeList = data.types;
          } else {
            this.typeList = [];
          }
        })
        .catch(err => {
          this.$dialog.error(err.msg || "获取分类失败");
        });
    },
    getTypeKey(item) {
      if (item && typeof item === "object") {
        return (
          item.name ||
          item.title ||
          item.label ||
          item.type_name ||
          item.value ||
          ""
        );
      }
      return String(item);
    },
    getTypeLabel(item) {
      if (item && typeof item === "object") {
        return item.name || item.title || item.label || item.type_name || "";
      }
      return item;
    },
    onImageUploading() {
      this.imageUploading = true;
    },
    finishImageUpload() {
      this.imageUploading = false;
    },
    onImageUploaded(res) {
      this.finishImageUpload();
      const url = res && res.data && res.data.url;
      if (!res || res.status !== 200 || !url) {
        return this.$dialog.error((res && res.msg) || "上传图片失败");
      }
      if (this.images.length < 3) {
        this.images.push(url);
      }
    },
    onUploadError(err) {
      this.finishImageUpload();
      this.$dialog.error(err || "上传图片失败");
    },
    removeImage(index) {
      this.images.splice(index, 1);
    },
    submit() {
      if (!this.canSubmit || this.submitting) {
        if (this.selectedType === "") {
          return this.$dialog.toast({ mes: "请选择分类" });
        }
        if (trim(this.content).length < 4) {
          return this.$dialog.toast({ mes: "反馈内容至少输入4个字" });
        }
        return;
      }
      const phone = trim(this.phone);
      if (phone && !/^1(3|4|5|7|8|9|6)\d{9}$/i.test(phone)) {
        return this.$dialog.toast({ mes: chs_phone.message("联系电话") });
      }
      this.submitting = true;
      submitFeedback({
        type: this.selectedType,
        content: trim(this.content),
        contact: phone,
        img_urls: this.images.join(",")
      })
        .then(res => {
          this.$dialog.success(res.msg || "提交成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 800);
        })
        .catch(err => {
          this.$dialog.error(err.msg || "提交失败");
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>

<style scoped>
.opinion-feedback {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 0.2rem 0.2rem 0;
  box-sizing: border-box;
}

.card {
  background-color: #fff;
  border-radius: 0.12rem;
  padding: 0.28rem 0.3rem;
  margin-bottom: 0.2rem;
}

.field-label {
  font-size: 0.3rem;
  color: #282828;
  line-height: 1.4;
}

.field-label.required::before {
  content: "* ";
  color: #e93323;
}

.type-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.24rem;
  gap: 0.16rem;
}

.type-item {
  padding: 0.12rem 0.28rem;
  border-radius: 0.3rem;
  background-color: #f5f5f5;
  font-size: 0.26rem;
  color: #666;
  line-height: 1.4;
}

.type-item.on {
  background-color: #fff1f0;
  color: #e93323;
}

.textarea-wrap {
  position: relative;
  margin-top: 0.24rem;
  background-color: #f7f7f7;
  border-radius: 0.12rem;
  padding: 0.24rem 0.24rem 0.56rem;
}

.textarea-wrap textarea {
  width: 100%;
  min-height: 2.2rem;
  border: none;
  outline: none;
  resize: none;
  background: transparent;
  font-size: 0.28rem;
  color: #282828;
  line-height: 1.6;
}

.textarea-wrap textarea::placeholder {
  color: #bbb;
}

.char-count {
  position: absolute;
  right: 0.24rem;
  bottom: 0.16rem;
  font-size: 0.22rem;
  color: #999;
}

.upload-list {
  flex-wrap: wrap;
  margin-top: 0.24rem;
}

.upload-pic {
  width: 1.56rem;
  height: 1.56rem;
  margin: 0 0.2rem 0.2rem 0;
  position: relative;
  border-radius: 0.08rem;
  overflow: hidden;
}

.upload-pic img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.upload-pic .icon-guanbi1 {
  position: absolute;
  top: -0.08rem;
  right: -0.08rem;
  font-size: 0.4rem;
  z-index: 2;
}

.upload-add {
  border: 1px dashed #ddd;
  color: #999;
  font-size: 0.22rem;
  line-height: 1.4;
  box-sizing: border-box;
}

.upload-add .iconfont {
  font-size: 0.44rem;
  color: #bbb;
  margin-bottom: 0.08rem;
}

.upload-tip {
  margin-top: 0.04rem;
}

.picUploadSlot {
  position: relative;
  width: 1.56rem;
  height: 1.56rem;
  margin: 0 0.2rem 0.2rem 0;
}

.picUploadSlot .upload-pic {
  width: 100%;
  height: 100%;
  margin: 0;
}

.picUploadMask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background: rgba(255, 255, 255, 0.92);
  border: 1px dashed #ddd;
  border-radius: 0.08rem;
  box-sizing: border-box;
  color: #999;
  font-size: 0.22rem;
  pointer-events: none;
}

.uploading-spinner {
  width: 0.4rem;
  height: 0.4rem;
  margin-bottom: 0.12rem;
  border: 0.04rem solid #e5e5e5;
  border-top-color: #e93323;
  border-radius: 50%;
  animation: opinion-feedback-upload-spin 0.8s linear infinite;
}

@keyframes opinion-feedback-upload-spin {
  to {
    transform: rotate(360deg);
  }
}

.phone-card {
  align-items: center;
}

.phone-label {
  flex-shrink: 0;
  margin-right: 0.2rem;
}

.phone-input {
  flex: 1;
  border: none;
  outline: none;
  text-align: right;
  font-size: 0.28rem;
  color: #282828;
  min-width: 0;
}

.phone-input::placeholder {
  color: #bbb;
  font-size: 0.26rem;
}

.submit-btn {
  margin: 0.4rem auto 0;
  width: 6.9rem;
  height: 0.86rem;
  line-height: 0.86rem;
  text-align: center;
  border-radius: 0.43rem;
  font-size: 0.32rem;
  color: #fff;
  background-color: #d9d9d9;
}

.submit-btn.active {
  background: linear-gradient(to right, #f35447 0%, #ff8e3c 100%);
}

.bottom-space {
  height: 0.6rem;
}
</style>
